import { render, staticRenderFns } from "./ds-data-table.vue?vue&type=template&id=e8ffe228&scoped=true"
import script from "./ds-data-table.vue?vue&type=script&lang=js"
export * from "./ds-data-table.vue?vue&type=script&lang=js"
import style0 from "./ds-data-table.vue?vue&type=style&index=0&id=e8ffe228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ffe228",
  null
  
)

export default component.exports